/*eslint-disable */

import Multiselect from 'vue-multiselect'
import {bus} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'shared-notes',
  components: {Multiselect},
  props: ['sharedModelINFO'],
  data () {
    return {
      submitted:false,
      userList:null,
      userListResults:[], 
      options:[],
      name:'',
      sentUserData:[],
      users:[],
      sharedModelId:'',
      groupUserList:null,
      groupUserListResults:[],
      groupOptions:[],
    }
  },
  computed: {

  },
  mounted () {
    this.getAllUserListMethod()
    this.name = this.sharedModelINFO.name
    this.sharedModelId = this.sharedModelINFO.id
  },
  methods: {
    getAllUserListMethod() {
     this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
       this.userList = res.data.data
       if(this.userList != undefined){
         this.userListResults = this.userList
         for(var i = 0; i < this.userListResults.length; i++){
           this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
         }
       }
     }).catch((err)=>{})
    },
    customGroupLabel ({ gName }) {
      return `${gName}`
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    sharedNotesMethod(){
      this.sentUserData = []
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          var data = {
            trained_model:this.sharedModelId,
            user:this.sentUserData,
            write_access:this.write_access
          }
          this.$store.dispatch('postSharedModelsForAiDashFun', data)
            .then((res) => { 
              toast.success(res.data.msg);
              this.submitted =  false
              this.sharedNotesPopupDisabledFun()
            }).catch((err) => {
              toast.error(err.data.msg);
              this.submitted =  false
            })
            return;
        }
      })
    },
    sharedNotesPopupDisabledFun(){
      document.body.classList.remove('body_right_scroll_remove')
      bus.$emit('sharedModelPopupBus', false);
      this.sentUserData = []
      this.sharedModelId = ''
      this.name = ''
    }
  }
}